import { excuseApi } from '../commons/http';


class Account {
  constructor(data = {}) {
    this.email = data.email;
    this.name = data.name;
    this.password = data.password;
    this.role = data.role;
    this.status = data.status;
    this.work_type = data.work_type || 'FULL_TIME';
  }

  mapData(data) {
    this.id = data.id;
    this.email = data.email;
    this.name = data.name;
    this.role = data.role;
    this.status = data.status;
    this.work_type = data.work_type;
  }

  async save() {
    const res = await excuseApi({
      path: '/accounts',
      method: 'POST',
      body: {
        name: this.name,
        email: this.email,
        password: this.password,
        role: this.role,
        status: this.status,
        work_type: this.work_type,
      }
    });
    if (res.status === 200 || res.status === 201) {
      return { success: true, message: "Thêm tài khoản thành công" };
    }
    else{
      return { sucess: false, message: "Đã xảy ra lỗi trong quá trình thêm nhân viên"};
    }
  }

  async activeInActive() {
    const newStatus = this.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    const res = await excuseApi({
      path: `/accounts/${this.id}`,
      method: 'PUT',
      body: {
        name: this.name,
        email: this.email,
        password: this.password,
        role: this.role,
        status: newStatus,
        work_type: this.work_type,
      }
    });
    if (res.status === 200 || res.status === 201) {
      this.status = newStatus;
      return res.data.data;
    }
  }

  async getAccountById(id) {
    try {
      const res = await excuseApi({
        path: `/accounts/${id}`,
        method: 'GET',
      });
      if (res.status === 200 || res.status === 201) {
        return res.data.data;
      }
      else {
        return null;
      }
    }
    catch (error) {
      throw error;
    }
  }

  async editAccount(id) {
    try {
      const res = await excuseApi({
        path: `/accounts/${id}`,
        method: 'PUT',
        body: {
          name: this.name,
          email: this.email,
          password: this.password,
          role: this.role,
          status: this.status,
          work_type: this.work_type,
        }
      });
      if (res.status === 200 || res.status === 201) {
        return {sucess: true, message: "Thay đổi thông tin thành công!", status:this.status};
      }
      else {
        return null;
      }
    }
    catch (error) {
      throw error;
    }
  }

  async changePassword(currentPassword,newPassword,confirmedPassword){
    const res = await excuseApi({
      path: '/current_account',
      method: 'GET',
    });
    if (res.status === 200 || res.status === 201) {
      if(newPassword === confirmedPassword){
        try{
          const res = await excuseApi({
            path: '/current_account',
            method: 'PUT',
            body: {
              current_password: currentPassword,
              password: newPassword,
            }
          })
          if(res.status === 200){
            return { success: true, message: "Đổi mật khẩu thành công" };
          }
        }
        catch(error){
          return { success: false, message: "Mật khẩu hiện tại sai" };
        }
      }
      else{
        return { success: false, message: "Mật khẩu mới và nhập lại mật khẩu không giống nhau!" };
      }
    }
    else {
      return null;
    }
  }

  async updateCheckIn(checkInId, data) {
    try {
      const res = await excuseApi({
        path: `/accounts/check-in/${checkInId}`,
        method: 'PUT',
        body: data,
      });
      if (res.status === 200) {
        return { success: true, message: "Cập nhật điểm danh thành công" };
      } else {
        return { success: false, message: "Cập nhật điểm danh thất bại" };
      }
    } catch (error) {
      throw error;
    }
  }
}

export default Account;
